module.exports = __webpack_public_path__ + "static/img/introuduct.9025117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introuduct.png
// module id = rFQ5
// module chunks = 0